module.exports = __webpack_public_path__ + "img/top_up_ewallet.792348fb.png";